class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Prevent body scrolling when mega menu is open
    if (this.mainDetailsToggle.open) {
      document.body.classList.add("overflow-hidden");
    } else {
      // Only remove overflow-hidden if no other mega menus are open
      const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
      if (openMegaMenus.length === 0) {
        document.body.classList.remove("overflow-hidden");
      }
    }

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  close() {
    super.close();
    // Remove overflow-hidden when closing
    const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
    if (openMegaMenus.length === 0) {
      document.body.classList.remove("overflow-hidden");
    }
  }
}

// Global click-outside handler for all mega menus
document.addEventListener('click', (e) => {
  // Get all open mega menus
  const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
  
  if (openMegaMenus.length > 0) {
    // Check if the click was inside any mega menu
    let clickedInsideMenu = false;
    
    openMegaMenus.forEach(menu => {
      if (menu.contains(e.target)) {
        clickedInsideMenu = true;
      }
    });
    
    // If click was outside all menus, close them all
    if (!clickedInsideMenu) {
      openMegaMenus.forEach(menu => {
        const headerMenu = menu.closest('header-menu');
        if (headerMenu) {
          headerMenu.close();
        } else {
          // Fallback: directly close the details element
          menu.removeAttribute('open');
        }
      });
      
      // Remove overflow-hidden since all menus are now closed
      document.body.classList.remove("overflow-hidden");
    }
  }
});

customElements.define("header-menu", HeaderMenu);
